import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import AC from "agora-chat";
import "./chat.css"; // Importing the CSS file

const APP_ID = "611323081#1524731";
const baseUrl = "https://admin.mrguru.in/";

const AgoraChat = () => {
    const { userId, adminId } = useParams();
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState("");
    const [token, setToken] = useState(null);
    const chatClient = useRef(null);
    const [adminInfo, setAdminData] = useState({});


    useEffect(() => {
        const get_admin_info = async () => {
            try {
                const response = await fetch(`${baseUrl}user_api/get_user_info?userId=${userId}`);
                const data = await response.json();
                console.log("data--->",data);
                console.log("data-1----------------->",data.results);

                if (data.status) {
                console.log("data-0----------------->",data.results);

                    setAdminData(data.results);
                } else {
                    console.error("Failed to get_admin_info");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
            }
        };

        get_admin_info();
    }, [userId]);

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await fetch(`${baseUrl}user_api/agora_chat_token?userId=${userId}`);
                const data = await response.json();
                if (data.token) {
                    setToken(data.token);
                } else {
                    console.error("Failed to fetch token");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
            }
        };
        fetchToken();
    }, [userId]);

    useEffect(() => {
        const initChat = async () => {
            if (!APP_ID || !token) return;

            try {
                if (chatClient.current && chatClient.current.isOpened()) {
                    await chatClient.current.close();
                }

                chatClient.current = new AC.connection({ appKey: APP_ID, multiDevice: true });
                chatClient.current.addEventHandler("connection&message", {
                    onConnected: () => console.log(`User ${userId} connected!`),
                    onDisconnected: () => console.log("User disconnected"),
                    onTextMessage: (message) => {
                        setMessages(prev => [...prev, { sender: message.from, text: message.msg, time: new Date() }]);
                    },
                });

                await chatClient.current.open({ user: userId, accessToken: token });
            } catch (error) {
                console.error("Error initializing Agora Chat:", error);
            }
        };

        if (token) {
            initChat();
        }

        return () => chatClient.current && chatClient.current.close();
    }, [userId, token]);

    const sendMessage = async () => {
        if (!messageInput.trim()) return;
        try {
            const msg = AC.message.create({
                chatType: "singleChat",
                type: "txt",
                to: adminId,
                msg: messageInput,
            });
            await chatClient.current.send(msg);
            setMessages(prev => [...prev, { sender: "Me", text: messageInput, time: new Date() }]);
            setMessageInput("");
        } catch (error) {
            console.error("Error sending message:", error);
        }
    };

    return (
        <div className="New__section">
            <div className="chat-container">
            <div className="chat-header">
                <img src={adminInfo.profile_img} alt="Profile" className="profile-pic" />
                <div>
                    <h3>{adminInfo.name}</h3>
                    <span className="online-status">● Online</span>
                </div>
                {/* <span className="chat-timer">30:00</span> */}
            </div>

            <div className="chat-box">
                {messages.map((msg, index) => (
                    <div key={index} className={`message ${msg.sender === "Me" ? "me" : "other"}`}>
                        <div className="message-text">{msg.text}</div>
                        <div className="message-time">{msg.time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
                    </div>
                ))}
            </div>

            <div className="chat-input">
                <input
                    type="text"
                    value={messageInput}
                    onChange={(e) => setMessageInput(e.target.value)}
                    placeholder="Type Message here..."
                />
                <button onClick={sendMessage}>➤</button>
            </div>
        </div>
        </div>
    );
};

export default AgoraChat;
